"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// export type FileToCloudURL = {
//   filePath: string;
//   cloudURL: string;
// };
// export type UploadEmployeeFilesContract = {
//   Params: { workspaceId: string; };
//   Body: FileToCloudURL[];
//   Reply: ApiResponse<FileToCloudURL[] | null>;
// };
